import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const printCode = async (codes) => {
	const form = {
		defaultUnit: 1000,
		ids: codes,
	};

	const { data } = await axios.post(`${API}/client/inventories/create_tags_pdf`, {
		...form,
	});
	return data;
};
